module.exports = {"apiUrl":"https://api.sheepoll.com/v1/","socketUrl":"wss://websocket.sheepoll.com"}


//////////////////
// WEBPACK FOOTER
// ./src/config.json
// module id = 298
// module chunks = 0